import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { ThemeProvider } from "../theme/ThemeProvider";
import { BookingFlow } from "../flow/BookingFlow";
import { useSession } from "../store/sessionStore";
import { LazyTyreFlow } from "./LazyTyreFlow";
import { isTyreDemo } from "../tyres/demo";

/**
 * Chrome-less surface for the iframe. Reads ?garage=<id> (and optional &mode=).
 * Transparent background so the host page shows through around the card.
 */
export function EmbedRoute() {
  const [params] = useSearchParams();
  const garageId = params.get("garage") ?? "";
  const config = useSession((s) => s.config);

  useEffect(() => {
    document.documentElement.classList.add("ap-embed-html");
    document.body.classList.add("ap-embed-root");
    return () => {
      document.documentElement.classList.remove("ap-embed-html");
      document.body.classList.remove("ap-embed-root");
    };
  }, []);

  if (!garageId) {
    return (
      <div
        style={{
          padding: 40,
          textAlign: "center",
          color: "var(--ap-ink-soft)",
        }}
      >
        Missing garage id. Add <code>?garage=&lt;id&gt;</code> to the URL.
      </div>
    );
  }

  if (params.get("product") === "tyres")
    return (
      <LazyTyreFlow
        key={`${garageId}-${params.get("demo")}`}
        garageId={garageId}
        demo={isTyreDemo(garageId, params.get("demo"))}
      />
    );

  return (
    <ThemeProvider theme={config?.theme}>
      <BookingFlow garageId={garageId} />
    </ThemeProvider>
  );
}
